<template>
    <div>
        <a-icon
            class="ml-0 ml-lg-2"
            :class="icon.iconClass"
            :icon="icon.icon"
            v-tooltip="icon.tooltip"
        />
    </div>
</template>

<script>
export default {
    props: {
        status: {
            type: Boolean,
            required: true
        },
        closingDate: {
            type: String
        }
    },
    computed: {
        icon() {
            let icon

            if (this.status) {
                if (this.closingDate) {
                    icon = {
                        icon: 'Warning',
                        iconClass: 'status-icon-warning',
                        tooltip: `Data wypowiedzenia: ${this.$moment(
                            this.closingDate
                        ).format('DD-MM-YYYY')}`
                    }
                } else {
                    icon = {
                        icon: 'Ok',
                        iconClass: 'status-icon-ok'
                    }
                }
            } else {
                icon = {
                    icon: 'ErrorCircle',
                    iconClass: 'status-icon-error'
                }
            }
            return icon
        }
    }
}
</script>
